import { Component } from '@angular/core'
import { TextAreaWidget } from 'ngx-schema-form'

@Component({
  selector: 'app-text-area-widget',
  templateUrl: './text-area-widget.component.html',
  styleUrls: ['./text-area-widget.component.scss'],
})
export class TextAreaWidgetComponent extends TextAreaWidget {}
